import { ReactElement, Suspense, lazy } from 'react';
import { Navigate as Redirect, Route, Routes } from 'react-router-dom';
import { ElectronicBillingProvider } from './context';
import { ElectronicBillingPath } from './routes';

const Companies = lazy(() => import('./pages/Company/Companies'));
const ApiKeyClients = lazy(() => import('./pages/ApiKeyClients/ApiKeyClients'));
const Documents = lazy(() => import('./pages/Documents/Documents'));
const MyDocuments = lazy(() => import('./pages/MyDocuments/MyDocuments'));
const MySummaries = lazy(() => import('./pages/MySummaries/MySummaries'));
const MyVoidedDocuments = lazy(() => import('./pages/MyVoidedDocuments/MyVoidedDocuments'));

export const ElectronicBillingRoutes: React.FC = (): ReactElement => {
  return (
    <Suspense>
      <Routes>
        <Route path={ElectronicBillingPath.Company} element={<Companies />} />
        <Route path={ElectronicBillingPath.ApiKeyClients} element={<ApiKeyClients />} />
        <Route path={ElectronicBillingPath.Documents} element={<Documents />} />
        <Route path={ElectronicBillingPath.MyDocuments} element={<MyDocuments />} />
        <Route path={ElectronicBillingPath.MySummaries} element={<MySummaries />} />
        <Route path={ElectronicBillingPath.MyVoidedDocuments} element={<MyVoidedDocuments />} />
        <Route path="*" element={<Redirect to={ElectronicBillingPath.Company} replace />} />
      </Routes>
    </Suspense>
  );
};

export const ElectronicBillingRouter: React.FC = () => (
  <ElectronicBillingProvider>
    <ElectronicBillingRoutes />
  </ElectronicBillingProvider>
);
